import type { AnchorHTMLAttributes, DetailedHTMLProps, MouseEventHandler } from 'react';
import React from 'react';
import { omit } from 'lodash-es';

export type MarkdownLinkProps = DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export default function MarkdownLink(props: MarkdownLinkProps) {
	const className = props.className ?? (props as { class: string })['class'];
	const propsWithoutClass = omit(props, 'class');

	const handleClicked: MouseEventHandler<HTMLAnchorElement> = (e) => {
		if (e.currentTarget.hasAttribute('data-tippy-content')) {
			e.preventDefault();
		}
	};

	return (
		<a
			{...propsWithoutClass}
			className={className}
			target={
				isExternalLink(propsWithoutClass.href ?? '') || propsWithoutClass.target === '_blank'
					? '_blank'
					: '_self'
			}
			onClick={handleClicked}
		/>
	);
}

const isExternalLink = (link: string) => {
	return link.startsWith('http');
};
